'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPermissions = exports.getUser = undefined;

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _entries = require('babel-runtime/core-js/object/entries');

var _entries2 = _interopRequireDefault(_entries);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _get3 = require('lodash/get');

var _get4 = _interopRequireDefault(_get3);

var _reselect = require('reselect');

var _strings = require('helpers/strings');

var _permissions = require('helpers/permissions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _getUser = function _getUser(state) {
  return state.auth.user;
};

function getPermissionFn(user) {
  var _ref = user || {},
      _ref$rightMngt = _ref.rightMngt,
      rightMngt = _ref$rightMngt === undefined ? {} : _ref$rightMngt;

  return function (permission) {
    return permission ? !!rightMngt[permission] : rightMngt;
  };
}

function processPermissions(user) {
  var getPermission = getPermissionFn(user);
  var res = (0, _extends3.default)({}, getPermission());
  (0, _entries2.default)(_permissions.permissionsMap).map(function (_ref2) {
    var _ref3 = (0, _slicedToArray3.default)(_ref2, 2),
        key = _ref3[0],
        field = _ref3[1];

    res[key] = getPermission(field);
  });

  return res;
}

var getUser = exports.getUser = (0, _reselect.createSelector)([_getUser], function (user) {
  if (user) {
    var res = (0, _extends3.default)({}, user);
    res.fullName = (0, _strings.concat)(' ', user.name, user.surname);
    res.permissions = processPermissions(user);
    res.type = (0, _get4.default)(user, 'rightMngt.accType');
    return res;
  }
  return null;
});

var getPermissions = exports.getPermissions = (0, _reselect.createSelector)([_getUser], function (user) {
  return processPermissions(user);
});


//////////////////
// WEBPACK FOOTER
// ./src/selectors/auth.js
// module id = 77
// module chunks = 1